import type { ServerConfig } from "./server-config";

export const config = {} as { services: ServerConfig }; // hehe

export const getConfig = async () => {
  const services: ServerConfig = await fetch("/config").then((r) => r.json());
  config.services = services;
  return config;
};

export type Config = typeof config;
